export const CHOPBOX_BRAND = "ChopBox";
